import { createAsyncThunk } from '@reduxjs/toolkit';

import { del, get, put, post } from './http';
import { activeSnack } from '../store/common';

export const createProjectCategory = createAsyncThunk(
  'project-category/create',
  async ({ state, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/project-category/admin/new`;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(
          getAllProjectCategorys({
            page: 1,
            search: '',
            dispatch,
            limit: sessionStorage.getItem('rowsPerPage_project_category'),
            district: '',
          })
        );
        dispatch(activeSnack({ type: 'success', message: 'Project Category created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllProjectCategorys = createAsyncThunk(
  'project-category/list',
  async ({ page, search, dispatch, limit }) => {
    try {
      const response = await get(
        `/project-category/admin/all?page=${page && page}&search=${search && search}&limit=${limit || 5}`
      );
      // console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getProjectCategoryDetails = createAsyncThunk(
  'project-category/single',
  async ({ projectCategoryId, dispatch }) => {
    try {
      // console.log('ID:', projectCategoryId);
      const response = await get(`/project-category/admin/${projectCategoryId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const updateProjectCategoryDetails = createAsyncThunk(
  'project-category/update',
  async ({ state, projectCategoryId, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/project-category/admin/${projectCategoryId}`;

      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        if (handleClear) {
          handleClear();
        }
        dispatch(
          getAllProjectCategorys({
            page: 1,
            search: '',
            dispatch,
            limit: sessionStorage.getItem('rowsPerPage_project_category'),
            district: '',
          })
        );
        dispatch(activeSnack({ type: 'success', message: 'Project Category updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const deleteProjectCategory = createAsyncThunk('project-category/delete', async ({ projectCategoryId, dispatch }) => {
  try {
    const response = await del(`/project-category/admin/${projectCategoryId}`);
    if (response) {
      dispatch(activeSnack({ type: 'success', message: 'Project Category deleted Successfully' }));
      return response?._id;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
